import { Box, Card, Center, Divider, Group, Text, Title, useMantineColorScheme } from "@mantine/core";
import { actionSection } from "./ActionCard.module.css";
import type { FC, PropsWithChildren } from "react";

export interface ActionCardProps extends PropsWithChildren {
  title: string;
  subTitle: React.ReactNode;
}

export const ActionCard: FC<ActionCardProps> = ({ title, subTitle, children }) => {
  const { colorScheme } = useMantineColorScheme();

  const bg = colorScheme === "dark"
    ? "dark.6"
    : "gray.1";

  return (
    <Card p="0rem">
      <Group gap={0}>
        <Box flex={1} p="xl">
          {typeof title === "string" && (
            <Title order={3}>
              {title}
            </Title>
          )}
          {typeof title !== "string" && (
            title
          )}

          {typeof subTitle === "string" && (
            <Text>
              {subTitle}
            </Text>
          )}
          {typeof subTitle !== "string" && (
            subTitle
          )}
        </Box>

        <Divider orientation="vertical" />

        <Center flex={1} p="xl" className={actionSection} bg={bg}>
          {children}
        </Center>
      </Group>
    </Card>
  );
};
